module.exports = __webpack_public_path__ + "img/rBACE1Xf2GiDWRtEAAIyHllkybA426_600x.e6dfb2aa.jpg";